import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Sidebar from "../../templates/Sidebar/Sidebar";
import Image from "../../atoms/Image/Image";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileLines, faXmark } from "@fortawesome/free-solid-svg-icons";
import { useAuth } from "../../../context/AuthContext";
import useRequest from "../../../context/useRequest";
import BookingHistoryCard from "../../templates/Dashboard/BookingHistory/BookingHistoryCard";

const BookingsHistory = () => {
  const [bookingHistory, setBookingHistory] = useState([]);
  const { userId } = useAuth();
  const { sendRequest } = useRequest();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const userDetails = { user_id: userId };
   
    const fetchUserAllBookings = async () => {
      try {
        const response = await sendRequest({
          method: "POST",
          url: `/cab/myBookings`,
          body: userDetails,
        });
        if (response.status) {
          setBookingHistory(response.data || []);
        }
      } catch (error) {
        console.error("Error fetching booking history:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUserAllBookings();
  }, [sendRequest, userId]);

  return (
    <>
      {/* {loading ? (
        <div className="loader">
          <Image src={commuteLoader} alt="loader" />
        </div>
      ) : ( */}
      <section className="bookings-history section-padding">
        <Container>
          <Row>
            <Col className="col-12 col-md-3">
              <Sidebar />
            </Col>
            <Col className="col-12 col-md-9">
              <BookingHistoryCard bookings={bookingHistory} loading={loading} />
            </Col>
          </Row>
        </Container>
      </section>
      {/* )} */}
    </>
  );
};

export default BookingsHistory;
